// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"609":"ff80dc08","787":"45cb09a4"}[chunkId] + ".chunk.js";
};